import { Search } from "lucide-react";
import { ReportCard } from "./primitives/ReportCard";
import { keywordRows, KEYWORD_FOOTNOTE } from "./keywordModel";

const TREND_CLS = { up: "text-emerald-700", down: "text-red-700", flat: "text-muted-foreground" };

// Paid tab. Hidden when `keywords` is empty/missing.
export default function KeywordTable({ keywords, chatgptVisibility, lang }) {
  const rows = keywordRows(keywords, chatgptVisibility, lang);
  if (!rows) return null;
  return (
    <ReportCard icon={<Search className="h-4 w-4" />} title="Ihre wichtigsten Suchbegriffe">
      <div className="overflow-x-auto" data-testid="keyword-table">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b text-xs uppercase tracking-wide text-muted-foreground">
              <th className="py-2 pr-3 font-semibold">Suchbegriff</th>
              <th className="py-2 pr-3 font-semibold">Suchen pro Monat</th>
              <th className="py-2 pr-3 font-semibold">Google Maps</th>
              <th className="py-2 font-semibold">ChatGPT</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.keyword} className="border-b last:border-0">
                <td className="py-2 pr-3 font-medium">
                  {r.keyword}
                  {(r.organic || r.top3) && (
                    <div className="mt-0.5 font-normal text-xs text-muted-foreground">
                      {r.organic && <div>{r.organic}</div>}
                      {r.top3 && <div>{r.top3}</div>}
                    </div>
                  )}
                </td>
                <td className="py-2 pr-3">
                  {r.searches}
                  {r.trend && <span className={`ml-1.5 ${TREND_CLS[r.trend.dir]}`}>{r.trend.arrow} {r.trend.text}</span>}
                </td>
                <td className="py-2 pr-3">{r.maps}</td>
                <td className="py-2">{r.chatgpt}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-sm text-muted-foreground">{KEYWORD_FOOTNOTE}</p>
    </ReportCard>
  );
}
